import gsap from "gsap";

const NUMBER = /^(\s*)(\d{1,3}(?:[  ]\d{3})+|\d+)/;

const counter = {
    run(el, delay) {
        const node = this.firstText(el);
        const match = node ? node.nodeValue.match(NUMBER) : null;

        if (!match) {
            return;
        }

        const digits = match[2].replace(/\D/g, '');
        const target = parseInt(digits, 10);
        const separator = (match[2].match(/[  ]/) || [''])[0];

        if (target < 10 || (!separator && digits.length === 4 && target >= 1900 && target <= 2100)) {
            return;
        }

        const original = node.nodeValue;
        const rest = original.slice(match[0].length);
        const state = { value: Math.pow(10, digits.length - 1) };
        const render = () => {
            node.nodeValue = match[1] + this.group(Math.round(state.value), separator) + rest;
        };

        render();
        gsap.to(state, {
            value: target,
            delay,
            duration: 1.6,
            ease: 'power2.out',
            onUpdate: render,
            onComplete: () => {
                node.nodeValue = original;
            },
        });
    },

    group(value, separator) {
        const text = String(value);

        return separator ? text.replace(/\B(?=(\d{3})+(?!\d))/g, separator) : text;
    },

    firstText(el) {
        const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
            acceptNode: (node) => (node.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP),
        });

        return walker.nextNode();
    },
};

export default counter;
